
    export default 
    {
    "tutorial_over_modal": {
        "dec": "Vai su Shopify - Impostazioni - Cassa per controllare se stai usando la funzione di evasione automatica, se sì, disattivala e salva le nuove impostazioni.",
        "dec2": "Ricorda che la funzione di evasione automatica di Shopify evaderà automaticamente gli ordini, impedendoti di inviarli ad AliExpress. Se questa funzione è attivata su Shopify, non potrai elaborare gli ordini su DSers."
    }
}